import { TestTube2, Database } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { useMode } from '@/providers/ModeProvider';

/**
 * Small inline badge that shows the current data mode (Demo/Live)
 * for the active screen. Place next to screen titles on the header line.
 */
export function DataModeBadge() {
  const { isDemo } = useMode();

  if (isDemo) {
    return (
      <Badge
        variant="outline"
        className="border-amber-500/50 bg-amber-500/10 text-amber-700 dark:text-amber-400 text-sm font-medium gap-2 px-5 py-1"
      >
        <TestTube2 className="h-5 w-5" />
        Demo
      </Badge>
    );
  }

  return (
    <Badge
      variant="outline"
      className="border-green-500/50 bg-green-500/10 text-green-700 dark:text-green-400 text-sm font-medium gap-2 px-5 py-1"
    >
      <Database className="h-5 w-5" />
      Live
    </Badge>
  );
}
